"use strict";

import { Collection } from "Collection";
import { FormButtonEventsModel } from 'Models/FormButtonEventsModel';
import { Objects } from "Constants/objects";
export var FormButtonEventsCollection = Collection.extend({
  model: FormButtonEventsModel,
  object: Objects.SysFormButtonEvents
});